// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__W_YWv","question":"style_question__iOyNg","text":"style_text__Rp83W","button":"style_button__l9JtJ"};